var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 0.5C13.4852 0.5 15.4999 2.51472 15.4999 5C15.4999 6.15298 15.0634 7.23825 14.297 8.06265L14.1546 8.20881L7.60926 14.754L7.56941 14.7911L7.52762 14.8248C7.0257 15.2569 6.38445 15.5 5.70717 15.5C4.16584 15.5 2.91634 14.2505 2.91634 12.7092C2.91634 12.0331 3.15861 11.3936 3.58801 10.8931L3.69923 10.7709L3.71054 10.7619L9.1788 5.2841C9.47144 4.99095 9.94631 4.99053 10.2395 5.28317C10.5326 5.5758 10.533 6.05068 10.2404 6.34383L4.77213 11.8217L4.76393 11.8279C4.54171 12.0656 4.41634 12.3766 4.41634 12.7092C4.41634 13.4221 4.99427 14 5.70717 14C5.99139 14 6.25984 13.9085 6.48059 13.7428L6.57218 13.6673L6.57277 13.6685L13.0996 7.1428L13.2185 7.01951C13.7173 6.47224 13.9999 5.75937 13.9999 5C13.9999 3.34315 12.6568 2 10.9999 2C10.2037 2 9.45899 2.31095 8.9036 2.85394L8.78754 2.97382L8.77368 2.98354L1.77972 9.9802C1.48689 10.2732 1.01201 10.2733 0.719056 9.98044C0.426097 9.68761 0.425991 9.21274 0.718819 8.91978L7.70054 1.93493L7.7355 1.90266C8.57842 1.01433 9.74873 0.5 10.9999 0.5Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.68d8c88c0da5ecf782423d9f49cc3e7d.svg";
export { ForwardRef as ReactComponent };